import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {CustomersService} from "app/services";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {fetchAllCustomers} from "./customers-list.slice";
import {UpdateCustomerTypes} from "app/types/service-types/CustomerTypes";

interface UpdateCustomerStateParams {
  id: string;
  body: UpdateCustomerTypes;
  onSuccess?: Function;
  onError?: Function;
}

export const updateCustomer = (params: UpdateCustomerStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await CustomersService.updateCustomer(params.id, params.body);
    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Customer changed successfully!' : 'Klienti u ndryshua me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllCustomers());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface DeleteCustomerSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DeleteCustomerSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'customer/update-customers',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;